// Itens de navegação do header do admin.
// `match` é o prefixo de path usado para marcar o link como ativo: telas de
// detalhe abaixo do prefixo mantêm o link de origem destacado.
export const primaryNav = [
  {
    title: 'Dashboard',
    icon: 'mdi-view-dashboard-outline',
    route: 'AdminDashboard',
    match: '/admin/dashboard',
  },
  {
    title: 'Requerimentos',
    icon: 'mdi-format-list-bulleted',
    route: 'ApplicationList',
    match: '/admin/requerimentos',
  },
  {
    title: 'Intimações',
    icon: 'mdi-alert-circle-outline',
    route: 'AdminSubpoenasList',
    match: '/admin/intimacoes',
  },
  {
    title: 'Clientes',
    icon: 'mdi-account-group-outline',
    route: 'CustomersList',
    match: '/admin/configuracao/users',
  },
  {
    title: 'Atualizar Requerente',
    icon: 'mdi-account-edit-outline',
    route: 'UpdateEntity',
    match: '/admin/configuracao/entity',
  },
];

export const settingsNav = [
  { title: 'Tipologias', icon: 'mdi-format-list-bulleted-type', route: 'TypologyList' },
  { title: 'Tipos de Requerimento', icon: 'mdi-file-send', route: 'ApplicationTypesList' },
  { title: 'Tipos de Documento', icon: 'mdi-file-document-box-multiple-outline', route: 'DocumentTypesList' },
  { title: 'Tipos de Estudo Ambiental', icon: 'mdi-leaf', route: 'EnviromentalStudyTypeList' },
  { title: 'Funcionários', icon: 'mdi-account-tie-outline', route: 'AdminsList' },
];
